import storeModule from '../../store-module'
import { defineStore } from 'pinia'

const url = 'dashboard/brokers-activities'

export default defineStore(
  'dashboard-brokers-activities',
  storeModule.createStoreModule('dashboard-brokers-activities', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
